import { getFileExtension } from 'helpers/helper_functions';
import { EXTENSION_BASED_MIMETYPES } from 'constants/DocumentDefaults';

export function areSomeFilesEmpty(files) {
  return files.some((file) => !file.size);
}

export function getFilesWithContentType(files) {
  return files.map((file) => {
    if (
      !file?.type?.length &&
      file?.name &&
      getFileExtension(file.name) &&
      EXTENSION_BASED_MIMETYPES[getFileExtension(file.name)]
    )
      return new File([file], file.name, {
        type: EXTENSION_BASED_MIMETYPES[getFileExtension(file.name)],
      });
    return file;
  });
}
